import { TFunction } from 'i18next';
import moment from 'moment';
import { BEHAVIOR } from '../constants';
import TRANSLATIONS from '../translations';
import momentLocaleRemap from './momentLocaleRemap';

export const renderTimeOnly = (timeString: Date, t: TFunction) => {
  const targetTime = moment(timeString);
  const time = targetTime.format(BEHAVIOR.TIME_FORMAT);
  const isAM = targetTime.locale('en').format('A') === 'AM';
  const translations = isAM ? TRANSLATIONS.COMMON.MESSAGE_TIMESTAMP_AM : TRANSLATIONS.COMMON.MESSAGE_TIMESTAMP_PM;
  return t(translations[0], translations[1], { time });
};

export const renderTimeText = (timeString: Date, t: TFunction, locale: string) => {
  const targetTime = moment(timeString);
  targetTime.locale(momentLocaleRemap(locale));

  const TODAY = moment().startOf('day');
  const YESTERDAY = moment().subtract(1, 'days').startOf('day');
  const A_WEEK_OLD = moment().subtract(7, 'days').startOf('day');

  if (targetTime.isSame(TODAY, 'd')) return renderTimeOnly(timeString, t);
  if (targetTime.isSame(YESTERDAY, 'd')) return t(...TRANSLATIONS.COMMON.YTD);
  if (targetTime.isAfter(A_WEEK_OLD)) return targetTime.format('dddd');
  return targetTime.format('L');
};
